import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params} from "@angular/router";
import {DoctorsService} from "../../services/doctors.service";

@Component({
  selector: 'app-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.css']
})
export class DoctorComponent implements OnInit {


  doctor = {
            "id": null,
            "title": null,
            "user": null,
            "phone_number": null,
            "billing_term": null,
            "billing_value": null
          };

  visits = [];

  constructor(private doctor_service: DoctorsService,
    private activatedRoute: ActivatedRoute,) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) =>{
        let doctorId = params['id'];
        this.doctor_service.getById(doctorId).subscribe(
          doctor =>{
            this.doctor = doctor

          }, error => {
            alert(error)
          }
        )
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/components/doctor/doctor.component.ts